export function logFactory(namespace: string) {
    return (...args:any[]) => {
        console.log(namespace, ...args)
    }
}
